import { useQueryState, parseAsBoolean, useQueryStates, parseAsString } from '@lib/queryState';

export const usePleaseLogIn = () => useQueryState('pleaseLogIn', parseAsBoolean);
export const usePleaseLogInAndRedirect = () =>
  useQueryStates({
    pleaseLogIn: parseAsBoolean,
    pleaseLogInRedirect: parseAsString
  });
